import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const SAFE_EMAIL_REGEX = /^(?!.*\.\.)([a-zA-Z0-9]+([._+-]?[a-zA-Z0-9]+)*)@(([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z]{2,})$/;

export function safeEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    return SAFE_EMAIL_REGEX.test(control.value) ? null : { email: true };
  };
}
